export const COUNTRY_COOKIE = "rc_country";
// Fired whenever the cookie changes client-side, so components can react without a page reload.
export const COUNTRY_COOKIE_EVENT = "rc-country-cookie-changed";

export function hasCountryCookie(): boolean {
  return document.cookie.split("; ").some((c) => c.startsWith(`${COUNTRY_COOKIE}=`));
}

export function getCountryCookie(): string | null {
  const match = document.cookie.split("; ").find((c) => c.startsWith(`${COUNTRY_COOKIE}=`));
  return match ? match.slice(COUNTRY_COOKIE.length + 1) : null;
}

export function setCountryCookie(value: string) {
  document.cookie = `${COUNTRY_COOKIE}=${value}; path=/; max-age=${60 * 60 * 24 * 365}`;
  window.dispatchEvent(new Event(COUNTRY_COOKIE_EVENT));
}

export function clearCountryCookie() {
  document.cookie = `${COUNTRY_COOKIE}=; path=/; max-age=0`;
  window.dispatchEvent(new Event(COUNTRY_COOKIE_EVENT));
}
